import React, { Component } from 'react';
import { connect } from 'react-redux';
import SelectOrganization from '../Components/SelectOrganization';
import { query, toggleShowFullForm, fillOrganizationList, setListValueByOrg, handleKeyDown, hideAutocomplete, setSelectedOrganization, changeOrganization, } from '../Actions/SelectOrganization.action';

let defaultValue = -1;
class SelectOrganizationContainer extends Component {


    constructor(props) {
        super(props);
        this.state = { ...props };
        this.clickHandler = this.clickHandler.bind(this);
        this.lastClickedNode = null;
        this.defaultOrgId = '';
    }

    componentDidMount() { 
        // Fill Organization list
        const { fillOrganizationList } = this.props;
        fillOrganizationList();
        
        document.addEventListener('mousedown', this.clickHandler);
        
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler);
    }

    componentWillUpdate({ showFullForm } = props) {
        if (this.state.showFullForm !== showFullForm) {
            this.setState({ ...this.state, showFullForm });
        }
    }

    clickHandler(event) {
        this.lastClickedNode = event.target;
    }

    onSelectOrg(org) {
        const { setListValueByOrg } = this.props; 
        setListValueByOrg(org);
    }

    selectOnChange(orgId) {
        //alert(orgId);
        const { setSelectedOrganization } = this.props;
        setSelectedOrganization(orgId);
    }

    onOrgSubmit() {
        const { changeOrganization } = this.props;
        changeOrganization(false);
    }

    onBlur() {
        const { showFullForm, toggleShowFullForm, hideAutocomplete } = this.props;
        
        if (!this.searchContainer.contains(this.lastClickedNode)) {
            showFullForm && toggleShowFullForm();
        }
        setTimeout(function () { hideAutocomplete(true); }, 500);
    }

    render() {
        const { query } = this.props;
        let defaultName = "";
        let defaultNumber = "";
        const $el = document.getElementById("selectOrganization");
        if ($el) {
            const selectedOrgId = $el.getAttribute("data-org-name");
            defaultName = selectedOrgId;
            const selectedOrgNumber = $el.getAttribute("data-org-number");
            defaultNumber = selectedOrgNumber;
        }
       
        return (
            <div ref={(elem) => this.searchContainer = elem} >
                {/*<h2 className="select-org__name">{defaultName} ({defaultNumber})</h2>*/}
                <SelectOrganization {...{ ...this.props, defaultName, defaultNumber, onBlur: () => this.onBlur(), onSelectOrg: (org) => this.onSelectOrg(org), onOrgSubmit: () => this.onOrgSubmit(), selectOnChange: (orgId) => this.selectOnChange(orgId) }} />
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        query: state.selectOrganization.query,
        result: state.selectOrganization.result,
        showResult: state.selectOrganization.showResult,
        showFullForm: state.selectOrganization.showFullForm,
        selectedItem: state.selectOrganization.selectedItem,
        defaultOrg: state.selectOrganization.defaultOrg,
        organizationList: state.selectOrganization.organizationList,
        selectedOrg: state.selectOrganization.selectedOrg,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSearch: (text) => dispatch(query(text)),
        toggleShowFullForm: () => dispatch(toggleShowFullForm()),
        fillOrganizationList: () => dispatch(fillOrganizationList()),
        changeOrganization: (skipConfirm) => dispatch(changeOrganization(skipConfirm)),
        hideAutocomplete: (hide) => dispatch(hideAutocomplete(hide)),
        setListValueByOrg: (org) => dispatch(setListValueByOrg(org)),
        setSelectedOrganization: (orgId) => dispatch(setSelectedOrganization(orgId)),
        onKeyDown: (event, opt) => dispatch(handleKeyDown(event, opt)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectOrganizationContainer);
